module.exports = __webpack_public_path__ + "img/7626dd3d888f3bdf196acd8de85ff2de.png";